import { COMPANY_CODE } from "../../client_identity";

/** Queryviz report identity for LMNT (org "Atomic" › project "LMNT").
 *  Slugs are derived server-side from names (see queryviz api-client-guide,
 *  "Report URLs") — org/project are fixed here; the report slug is the
 *  optional :reportSlug route param so deep links and the in-frame report
 *  picker both work. Bare /reporting has no default report — it shows the
 *  reports landing list (see ReportsLanding). */
export const QUERYVIZ_ORG_SLUG = "atomic";
export const QUERYVIZ_PROJECT_SLUG = COMPANY_CODE;

/** App route the reporting tab lives under (Sidebar + routes.tsx must match). */
export const QUERYVIZ_REPORT_BASE_PATH = "/reporting";

/** The Demand primary tab is the same reporting embed pinned to a single
 *  report (Sales Forecast) under its own /demand route, so clicking Demand
 *  shows only that report. */
export const DEMAND_REPORT_SLUG = "SalesForecast";
export const DEMAND_BASE_PATH = "/demand";

/** Mint embed tokens with the queryviz default TTL; rotation posts
 *  queryviz:set-embed-token into the live iframe before expiry. */
export const EMBED_TOKEN_TTL_SECONDS = 900;
